/* DfG PDP gallery color grouping (stacked layout)
 * ONLY acts on products that have color-tagged media (#color_ in alt -> data-color-group).
 * For those (the Complete Sets): shows the selected colorway's images + shared 'global'
 * images, stacked full-width in order, and injects the hide rule the stacked layout lacks.
 * Products with no color tags are left completely alone (native behavior preserved).
 */
(function () {
  function handleize(s) {
    return (s || '')
      .toString().trim().toLowerCase()
      .replace(/[‘’'\"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function activeColor() {
    var radios = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      var nm = (radios[i].name || '') + ' ' + (radios[i].getAttribute('data-option-name') || '');
      if (/colorway|colour|color/i.test(nm)) return handleize(radios[i].value);
    }
    var sel = document.querySelector('select[name*="Colorway" i], select[name*="Color" i]');
    if (sel && sel.value) return handleize(sel.value);
    return null;
  }

  var applying = false;
  var observer = null;
  var styleInjected = false;

  function injectCSS() {
    if (styleInjected) return;
    styleInjected = true;
    var css = '.product__images--no-thumbs .product__slide.media--hidden{display:none !important;}' +
              '.product__images--mobile-slider .product__slide.media--hidden{display:none !important;}';
    var st = document.createElement('style');
    st.setAttribute('data-dfg-gallery', '');
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }

  function isTaggedProduct(slides) {
    for (var i = 0; i < slides.length; i++) {
      if ((slides[i].getAttribute('data-color-group') || 'global') !== 'global') return true;
    }
    return false;
  }

  function filterGallery() {
    var slides = document.querySelectorAll('.product__slide[data-color-group]');
    if (!slides.length) return;
    // Safety: only manage products that actually use color tagging (the Complete Sets)
    if (!isTaggedProduct(slides)) return;
    var color = activeColor();
    if (!color) return;
    injectCSS();
    slides.forEach(function (s) {
      var g = s.getAttribute('data-color-group') || 'global';
      var show = g === color || g === 'global';
      s.classList.toggle('media--hidden', !show);
      if (show) s.classList.remove('media--active');
    });
  }

  function observeTargets() {
    if (!observer) return;
    observer.disconnect();
    document.querySelectorAll('product-images, .product__slides').forEach(function (t) {
      observer.observe(t, { attributes: true, attributeFilter: ['class', 'style'], subtree: true });
    });
  }

  function apply() {
    if (applying) return;
    applying = true;
    if (observer) observer.disconnect();
    try { filterGallery(); } catch (e) {}
    observeTargets();
    setTimeout(function () { applying = false; }, 50);
  }

  function burst() {
    [60, 250, 550, 900, 1400, 2000].forEach(function (d) { setTimeout(apply, d); });
  }

  function init() {
    observer = new MutationObserver(function () { if (!applying) setTimeout(apply, 60); });
    burst();
    observeTargets();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="radio"], select')) burst();
    });
    ['variant:changed', 'theme:variant:change', 'variantChange', 'product:variant-change', 'on:variant:change'].forEach(function (ev) {
      document.addEventListener(ev, burst);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();